module.exports = __webpack_public_path__ + "img/SL7_4681-Bearbeitet.9ae7343b.jpg";